import(/* webpackMode: "eager" */ "/opt/bitnami/apache/htdocs/matco-v2-back/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/bitnami/apache/htdocs/matco-v2-back/src/components/ui/Header/Header.tsx");
